import {Component, Injector} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {getTranslation} from 'shared/helpers/get-translation';

import {QuestionPage} from '../../components/question-page/question-page';
import {MultiSlider, Question, SliderKeypoint} from '../../model/model';
import { NavService } from 'shared/nav/nav.service';

interface TranslatedKeypoint {
  title: string;
  value: number;
}

interface SliderConfig {
  value: number;
  minLabel: string;
  maxLabel: string;
  isSnapping: boolean;
  ticks: number;
  keyPoints: Array<TranslatedKeypoint>;
}

const MID_VALUE: number = 50;

@Component({
  selector: 'multi-slider-page',
  templateUrl: 'multi-slider-page.html',
  styleUrls: ['multi-slider-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class MultiSliderPage extends QuestionPage {

  public sliderConfigs: Array<SliderConfig> = [];

  constructor(
    private translateService: TranslateService,
    private injector: Injector,
    public navService: NavService,
  ) {
    super(injector, navService);

    const multiSlider: MultiSlider = <MultiSlider> this.question.type;
    const lang: string = this.translateService.currentLang;
    const defaultLang: string = this.translateService.getDefaultLang();

    multiSlider.sliders.forEach((slider) => {
      let tickInterval: number;
      if (multiSlider.isSnapping && slider.keyPoints.length > 1) {
        tickInterval = slider.keyPoints[1].value;
      }

      const config: SliderConfig = {
        value: MID_VALUE,
        keyPoints: slider.keyPoints
          .map((keypoint: SliderKeypoint) => {
            const title: string = getTranslation(keypoint.title, this.translateService);
            return { value: keypoint.value, title: title };
          })
          .sort((keypoint1: TranslatedKeypoint, keypoint2: TranslatedKeypoint) => { return keypoint1.value - keypoint2.value; }),
        minLabel: getTranslation(slider.minText, this.translateService),
        maxLabel: getTranslation(slider.maxText, this.translateService),
        isSnapping: multiSlider.isSnapping,
        ticks: tickInterval,
      };
      this.sliderConfigs.push(config);
    });
  }

  private findKeypoint(config: SliderConfig): TranslatedKeypoint {
    const nextIndex: number = config.keyPoints.findIndex((keypoint) => { return keypoint.value > config.value; });
    if (nextIndex < 1) {
      return config.keyPoints[config.keyPoints.length - 1];
    }

    return config.keyPoints[nextIndex - 1];
  }

  public getLabelForSlider(config: SliderConfig): string {
    const keypoint: TranslatedKeypoint = this.findKeypoint(config);
    if (keypoint) {
      return keypoint.title;
    }

    return '';
  }

  public onNextClick(): void {
    this.answerSelected.emit(this.sliderConfigs.map((config) => {
      const keypoint: TranslatedKeypoint = this.findKeypoint(config);
      if (keypoint) {
        return config.keyPoints.indexOf(keypoint);
      }

      return 0;
    }));
  }
}
